export class NoopTaskCatalog {
    registerTaskMetadata(task) {
        // noop
    }
    registerTaskFileMetadata(id, metadata) {
        // noop
    }
    updateTaskMetadata(id, updates) {
        // noop
    }
    listTaskManifests() {
        return [];
    }
    getTaskManifest(id) {
        return undefined;
    }
    getTask(id) {
        return undefined;
    }
    taskExists(id) {
        return false;
    }
    disable() {
        // noop
    }
}
//# sourceMappingURL=noopTaskCatalog.js.map